import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import {
  SerializerFactory1qv9hivitncuv as SerializerFactory,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { ConditionSerializer21tf3x2n3amih as ConditionSerializer } from './ConditionSerialization.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Always_getInstancecs10mhg5aot2 as Always_getInstance } from './Condition.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { SortPartSerializer1fx0t5bmnpc8h as SortPartSerializer } from './SortPartSerializer.mjs';
import { ArrayListSerializer7k5wnrulb3y6 as ArrayListSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/CollectionSerializers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { IntSerializer_getInstance2q7s8kvk1il5u as IntSerializer_getInstance } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Primitives.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningdb.Query', null, 4);
        tmp0_serialDesc.a1b('condition', true);
        tmp0_serialDesc.a1b('orderBy', true);
        tmp0_serialDesc.a1b('skip', true);
        tmp0_serialDesc.a1b('limit', true);
        this.m3l_1 = tmp0_serialDesc;
      }
      b2j(typeSerial0) {
        return $serializer().n49(typeSerial0);
      }
      f1c(typeParamsSerializers) {
        return this.b2j(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      static o49() {
        var $this = createThis(this);
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningdb.Query', $this, 4);
        tmp0_serialDesc.a1b('condition', true);
        tmp0_serialDesc.a1b('orderBy', true);
        tmp0_serialDesc.a1b('skip', true);
        tmp0_serialDesc.a1b('limit', true);
        $this.l49_1 = tmp0_serialDesc;
        return $this;
      }
      p49(encoder, value) {
        var tmp0_desc = this.l49_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !value.q49_1.equals(Always_getInstance())) {
          tmp1_output.c15(tmp0_desc, 0, new (ConditionSerializer())(this.m49_1), value.q49_1);
        }
        var tmp;
        if (tmp1_output.h15(tmp0_desc, 1)) {
          tmp = true;
        } else {
          // Inline function 'kotlin.collections.listOf' call
          var tmp$ret$0 = emptyList();
          tmp = !equals(value.r49_1, tmp$ret$0);
        }
        if (tmp) {
          tmp1_output.c15(tmp0_desc, 1, new (ArrayListSerializer())(new (SortPartSerializer())(this.m49_1)), value.r49_1);
        }
        if (tmp1_output.h15(tmp0_desc, 2) ? true : !(value.s49_1 === 0)) {
          tmp1_output.v14(tmp0_desc, 2, value.s49_1);
        }
        if (tmp1_output.h15(tmp0_desc, 3) ? true : !(value.t49_1 === 100)) {
          tmp1_output.v14(tmp0_desc, 3, value.t49_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.p49(encoder, value instanceof Query() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.l49_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = 0;
        var tmp7_local3 = 0;
        var tmp8_input = decoder.l13(tmp0_desc);
        if (tmp8_input.a14()) {
          tmp4_local0 = tmp8_input.x13(tmp0_desc, 0, new (ConditionSerializer())(this.m49_1), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp8_input.x13(tmp0_desc, 1, new (ArrayListSerializer())(new (SortPartSerializer())(this.m49_1)), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp8_input.q13(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp8_input.q13(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp8_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp8_input.x13(tmp0_desc, 0, new (ConditionSerializer())(this.m49_1), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp8_input.x13(tmp0_desc, 1, new (ArrayListSerializer())(new (SortPartSerializer())(this.m49_1)), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp8_input.q13(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp8_input.q13(tmp0_desc, 3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp8_input.m13(tmp0_desc);
        return Query().u49(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
      }
      az() {
        return this.l49_1;
      }
      r1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [new (ConditionSerializer())(this.m49_1), new (ArrayListSerializer())(new (SortPartSerializer())(this.m49_1)), IntSerializer_getInstance(), IntSerializer_getInstance()];
      }
      s1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [this.m49_1];
      }
      static n49(typeSerial0) {
        var $this = this.o49();
        $this.m49_1 = typeSerial0;
        return $this;
      }
    }
    initMetadataForClass($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var QueryClass;
function Query() {
  if (QueryClass === VOID) {
    class $ {
      constructor(condition, orderBy, skip, limit) {
        Companion_getInstance();
        condition = condition === VOID ? Always_getInstance() : condition;
        var tmp;
        if (orderBy === VOID) {
          // Inline function 'kotlin.collections.listOf' call
          tmp = emptyList();
        } else {
          tmp = orderBy;
        }
        orderBy = tmp;
        skip = skip === VOID ? 0 : skip;
        limit = limit === VOID ? 100 : limit;
        this.q49_1 = condition;
        this.r49_1 = orderBy;
        this.s49_1 = skip;
        this.t49_1 = limit;
      }
      v49(condition, orderBy, skip, limit) {
        return new (Query())(condition, orderBy, skip, limit);
      }
      w49(condition, orderBy, skip, limit, $super) {
        condition = condition === VOID ? this.q49_1 : condition;
        orderBy = orderBy === VOID ? this.r49_1 : orderBy;
        skip = skip === VOID ? this.s49_1 : skip;
        limit = limit === VOID ? this.t49_1 : limit;
        return $super === VOID ? this.v49(condition, orderBy, skip, limit) : $super.v49.call(this, condition, orderBy, skip, limit);
      }
      toString() {
        return 'Query(condition=' + toString(this.q49_1) + ', orderBy=' + toString(this.r49_1) + ', skip=' + this.s49_1 + ', limit=' + this.t49_1 + ')';
      }
      hashCode() {
        var result = this.q49_1.hashCode();
        result = imul(result, 31) + hashCode(this.r49_1) | 0;
        result = imul(result, 31) + this.s49_1 | 0;
        result = imul(result, 31) + this.t49_1 | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Query()))
          return false;
        if (!this.q49_1.equals(other.q49_1))
          return false;
        if (!equals(this.r49_1, other.r49_1))
          return false;
        if (!(this.s49_1 === other.s49_1))
          return false;
        if (!(this.t49_1 === other.t49_1))
          return false;
        return true;
      }
      static u49(seen0, condition, orderBy, skip, limit, serializationConstructorMarker) {
        Companion_getInstance();
        if (!(0 === (0 & seen0))) {
          throwMissingFieldException(seen0, 0, Companion_getInstance().m3l_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.q49_1 = Always_getInstance();
        else
          $this.q49_1 = condition;
        if (0 === (seen0 & 2)) {
          var tmp = $this;
          // Inline function 'kotlin.collections.listOf' call
          tmp.r49_1 = emptyList();
        } else
          $this.r49_1 = orderBy;
        if (0 === (seen0 & 4))
          $this.s49_1 = 0;
        else
          $this.s49_1 = skip;
        if (0 === (seen0 & 8))
          $this.t49_1 = 100;
        else
          $this.t49_1 = limit;
        return $this;
      }
    }
    initMetadataForClass($, 'Query', Query, VOID, VOID, VOID, VOID, {0: Companion_getInstance});
    QueryClass = $;
  }
  return QueryClass;
}
//region block: exports
export {
  $serializer as $serializert1ehsr3tkdsu,
  Query as Query38t34cs21ulcf,
  Companion_getInstance as Companion_getInstance1p5xjdbhmj22t,
};
//endregion

//# sourceMappingURL=Query.mjs.map
